<script setup>
import { computed } from 'vue';
import { BaseEdge, Position, getSmoothStepPath } from '@vue-flow/core';

const props = defineProps({
  id: { type: String, required: true },
  sourceX: { type: Number, required: true },
  sourceY: { type: Number, required: true },
  targetX: { type: Number, required: true },
  targetY: { type: Number, required: true },
  sourcePosition: { type: String, default: Position.Right },
  targetPosition: { type: String, default: Position.Left },
  markerEnd: { type: String, default: undefined },
});

const path = computed(
  () =>
    getSmoothStepPath({
      sourceX: props.sourceX,
      sourceY: props.sourceY,
      sourcePosition: props.sourcePosition,
      targetX: props.targetX,
      targetY: props.targetY,
      targetPosition: props.targetPosition,
    })[0]
);
</script>

<template>
  <!-- Everything a connection offers lives in its right-click menu, which vue-flow raises from
       the edge itself - so this only has to draw the line. The widened hit area is what makes
       that right-click land: the stroke is dashed, and `pointer-events: visibleStroke` would
       otherwise ignore the gaps between dashes. -->
  <BaseEdge
    :id="id"
    :path="path"
    :marker-end="markerEnd"
    :interaction-width="24"
  />
</template>
